import classNames from 'classnames';
import React from 'react';
import Typography from '@/components/atoms/typography/typography';
import Lightbox from '@/components/utilities/lightbox/lightbox';
import { useI18n } from '@/libraries/contexts/i18n-context';
import styles from './save-companion-details-modal.module.scss';

export interface SaveCompanionDetailsModalProps {
  /** The class name to apply */
  className?: string;
  /** Indicates whether the modal is open */
  isOpen: boolean;
  /** The callback to handle the close event */
  onClose: () => void;
}

const SaveCompanionDetailsModal = ({
  className,
  isOpen = false,
  onClose,
}: SaveCompanionDetailsModalProps) => {
  const { t } = useI18n();

  return (
    <Lightbox
      className={classNames(styles.component, className)}
      isCentered
      isFullWidthOnMobile
      isOpen={isOpen}
      onClose={onClose}
      size="small"
      wrapperClassName={styles.lightboxWrapper}
    >
      <div className={styles.lightboxInnerWrapper}>
        <div className={styles.contentWrapper}>
          <div className={styles.content}>
            <Typography className={styles.text} tagStyle="bodyMedium">
              {t('items.profile.profilePage.saveCompanionInfoText')}
            </Typography>
          </div>
        </div>
      </div>
    </Lightbox>
  );
};

SaveCompanionDetailsModal.displayName = 'SaveCompanionDetailsModal';

export default SaveCompanionDetailsModal;
